import {createEvent, createStore} from 'effector';

export const openSidebar = createEvent();
export const closeSidebar = createEvent();

export const isSidebarOpened$ = createStore<boolean>(false);
